import { motion } from "framer-motion";
import { NIA_TRANSPORT, NIA_NODES, NIA_HUB } from "../data/site";

const toD = (pts) => pts.map((p, i) => `${i === 0 ? "M" : "L"} ${p[0]} ${p[1]}`).join(" ");

export function MobilityMapSvg({ active, filterId = "glowMob", showLabels = true, className = "w-full h-auto" }) {
  const current = NIA_TRANSPORT.find((m) => m.id === active);
  return (
    <svg viewBox="0 0 960 620" className={className} role="img" aria-label="Noida International Airport multimodal transport map">
      <defs>
        <filter id={filterId} x="-50%" y="-50%" width="200%" height="200%">
          <feGaussianBlur stdDeviation="3.5" result="b" />
          <feMerge><feMergeNode in="b" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>
      {Array.from({ length: 11 }).map((_, i) => <line key={`v${i}`} x1={i * 96} y1="0" x2={i * 96} y2="620" stroke="#161616" strokeWidth="1" />)}
      {Array.from({ length: 7 }).map((_, i) => <line key={`h${i}`} x1="0" y1={i * 96} x2="960" y2={i * 96} stroke="#161616" strokeWidth="1" />)}

      {NIA_TRANSPORT.filter((m) => m.id !== active).map((m) =>
        m.paths.map((pts, i) => (
          <path key={`${m.id}-${i}`} d={toD(pts)} fill="none" stroke="#3a3a3a" strokeWidth="1" strokeDasharray={m.dashed ? "5 6" : "0"} />
        ))
      )}
      {current.paths.map((pts, i) => (
        <motion.path
          key={`${current.id}-${i}`}
          d={toD(pts)}
          fill="none" stroke="#D4AF37" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
          strokeDasharray={current.dashed ? "8 8" : "0"} filter={`url(#${filterId})`}
          initial={{ pathLength: 0, opacity: 0 }} animate={{ pathLength: 1, opacity: 1 }}
          transition={{ duration: 1.1, delay: i * 0.15, ease: "easeInOut" }}
          data-testid={`mobility-route-${current.id}-${i}`}
        />
      ))}

      {NIA_NODES.map((n) => (
        <g key={n.label}>
          <circle cx={n.x} cy={n.y} r="4" fill="#0A0A0A" stroke="#D4AF37" strokeWidth="1.2" />
          {showLabels && (
            <text x={n.x} y={n.y - 11} textAnchor={n.anchor || "middle"} fill="#A1A1AA" fontSize="10" letterSpacing="1.2" style={{ fontFamily: "Manrope" }}>
              {n.label.toUpperCase()}
            </text>
          )}
        </g>
      ))}

      <motion.circle cx={NIA_HUB.x} cy={NIA_HUB.y} r="10" fill="#D4AF37" filter={`url(#${filterId})`} initial={{ r: 10 }} animate={{ r: [10, 14, 10] }} transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }} />
      <text x={NIA_HUB.x} y={NIA_HUB.y + 36} textAnchor="middle" fill="#F3E5AB" fontSize="13" letterSpacing="3" style={{ fontFamily: "Manrope" }}>NOIDA INTERNATIONAL AIRPORT</text>
      {showLabels && (
        <text x={NIA_HUB.x} y={NIA_HUB.y + 52} textAnchor="middle" fill="#71717A" fontSize="9.5" letterSpacing="2" style={{ fontFamily: "Manrope" }}>GROUND TRANSPORTATION CENTRE</text>
      )}
    </svg>
  );
}
